import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, withLatestFrom } from 'rxjs/operators';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import * as DashboardActions from './dashboard.actions';
import * as sharedAction from '../shared/shared.actions';
import * as UserDetailsActions from '../user-details/user-details.actions';
import * as dashboardSelecor from './dashboard.selectors';
import { select, Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from '../../services/shared/shared.service';

@Injectable()
export class DashboardEffects {
  private actions$ = inject(Actions);

  // Effects for getDashboardData
  getDashboardData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.getDashboardData),
      withLatestFrom(this.store.pipe(select(dashboardSelecor.GetUserDashboardData))),
      exhaustMap(action => {
        return this.dashboard.getDashboardData().pipe(
          map((data: any) => {
            const userTypeHash = this._sharedService.encodeURIComponentParam(data?.data?.userType);
            this.cookieService.set('u_type', userTypeHash);
            this.cookieService.set(
              'redirectToPreference',
              JSON.stringify(data.data?.redirectToPreference)
            );
            return DashboardActions.getDashboardDataSuccess({
              userDashboardData: data.data,
            });
          }),
          catchError((error: any) => of(DashboardActions.getDashboardDataFailure(error)))
        );
      })
    )
  );

  getDashboardDataSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.getDashboardDataSuccess),
      exhaustMap(action => {
        return of(
          UserDetailsActions.loggedInUserProfileSuccess({ profileData: null }),
          UserDetailsActions.loggedInUserProfile()
        );
      })
    )
  );

  constructor(
    private dashboard: DashboardService,
    private store: Store,
    private cookieService: CookieService,
    private _sharedService: SharedService
  ) {}
}
